import FilterNav from '../../molecules/filterNav/FilterNav';
import styles from './SearchItemContainer.module.scss';
import BoxContainer from '../../molecules/boxContainer/BoxContainer';
import ButtonBox from '../../atoms/buttonBox/ButtonBox';
import PropTypes from "prop-types";
import { isArrayNotEmpty } from '../../../utils/helperServices';

const contractDurationMobile = (props) => {

  const resetContractDuration = () => {
    props.setSelectedFilter(props.tempSelectedFilter);
  };
	
	const handleBack = () => {
		resetContractDuration();
		props.hideContractDuraiton();
	}

	return (
    <div className={styles.navGutter}>
      <FilterNav
        headingName="Contract duration"
        backbtn={handleBack}
        resetClickHandler={props.resetClickHandler}
        selectedFilter={isArrayNotEmpty(props?.selectedFilter?.contractduration) }
      />
      {props.contarctDuraitonMob.map((promo) => (
        <BoxContainer
          key={promo.id}
          boxHeading={`${promo.label} months`}
          selected={props.isContractDurationChecked(promo)}
          selectHandler={(flag) =>
            props.contractdurationClickHandler(flag, promo)
          }
        />
      ))}

      <ButtonBox
        children="Save Selection"
        className={styles["botton-box"]}
        click={props.hideContractDuraiton}
      />
    </div>
  );
};


contractDurationMobile.propTypes = {
	id: PropTypes.string,
	hideContractDuraiton: PropTypes.bool,
	resetClickHandler: PropTypes.func,
	contarctDuraitonMob: PropTypes.array,
	isContractDurationChecked: PropTypes.func,
	contractdurationClickHandler: PropTypes.func,
	selectedFilter:PropTypes.object,
  tempSelectedFilter: PropTypes.object
};

export default contractDurationMobile;